<div class="main-container message-col">
  <ion-content #content>
    <!-- <h3 class="skinnier" style="padding: 15px 15px 0 15px">{{ conversation?.title }}</h3> -->
    <ion-toolbar class="sticky-toolbar">
      <div class="toolbar-container">
        <div class="flexed header-container">
          <ion-buttons slot="start" [hidden]="isSidebarMode">
            <ion-button (click)="dismiss()">
              <ion-icon name="chevron-back-outline"></ion-icon>
            </ion-button>
          </ion-buttons>
          <ion-title mode="md" style="padding: 10px; width: 100%; color: var(--ion-color-step-600)">
            Conversation
            <span class="clickable" (click)="copyFriendlyId()">{{
              conversation?.friendlyId ? '#' + conversation?.friendlyId : ''
            }}</span>
            <span
              *ngIf="conversation?.excludeAnalytics"
              ngxTippy
              [tippyProps]="{
                touch: false,
                arrow: false,
                placement: 'bottom',
                content: 'Excluded from analytics'
              }"
            >
              <ion-icon name="cloud-offline-outline" class="padded-icon-left"></ion-icon>
            </span>
            <span
              *ngIf="conversation?.lockedAt"
              ngxTippy
              [tippyProps]="{
                touch: false,
                arrow: false,
                placement: 'bottom',
                content: 'Conversation will not reopen for new replies'
              }"
            >
              <ion-icon name="lock-closed-outline" class="padded-icon-left"></ion-icon>
            </span>
          </ion-title>
        </div>
        <div [hidden]="isInvalidConversation">
          <ion-button
            (click)="showConversationOptions()"
            class="nav-button"
            color="dark"
            fill="clear"
            ngxTippy
            [tippyProps]="{
              touch: false,
              arrow: false,
              placement: 'bottom',
              content: 'Show conversation options'
            }"
          >
            <ion-icon name="ellipsis-horizontal"></ion-icon>
          </ion-button>
          <ion-button
            (click)="showViewOptions()"
            class="nav-button hidden-sm"
            color="dark"
            fill="clear"
            ngxTippy
            [tippyProps]="{
              touch: false,
              arrow: false,
              placement: 'bottom',
              content: 'Show display options'
            }"
          >
            <ion-icon name="options"></ion-icon>
          </ion-button>
          <ion-button
            (click)="openConversationInSlack()"
            class="nav-button hidden-sm"
            color="dark"
            fill="clear"
            ngxTippy
            *ngIf="!isDashboardBased"
            [tippyProps]="{
              touch: false,
              arrow: false,
              placement: 'bottom',
              content: 'Click to open this conversation in the Unthread app for Slack  (Shift + 🆂)'
            }"
          >
            <ion-icon name="logo-slack"></ion-icon>
          </ion-button>
          <ion-button
            (click)="snooze()"
            ngxTippy
            [disabled]="isLoadingConversation || disableButtons"
            class="nav-button"
            color="dark"
            fill="clear"
            [tippyProps]="{
              touch: false,
              arrow: false,
              placement: 'bottom',
              content: 'Set a reminder and put on hold  (Shift + 🆉)'
            }"
          >
            <ion-icon name="alarm-outline"></ion-icon>
          </ion-button>
          <ion-button
            (click)="closeConversation()"
            ngxTippy
            [disabled]="isLoadingConversation || disableButtons"
            *ngIf="conversation?.status !== 'closed'"
            class="nav-button btn-small close-button"
            color="light"
            style="margin: 0 8px"
            [tippyProps]="{
              touch: false,
              arrow: false,
              placement: 'bottom',
              content: 'Mark this conversation as resolved  ⌘⇧🅴'
            }"
          >
            <ion-icon name="checkmark"></ion-icon>
            <span class="text-with-left-icon hidden-sm">Close</span>
          </ion-button>
          <ion-button
            (click)="reopenConversation()"
            ngxTippy
            [disabled]="isLoadingConversation || disableButtons"
            *ngIf="conversation?.status === 'closed'"
            class="nav-button btn-small"
            style="margin: 0 8px"
            color="light"
            [tippyProps]="{
              touch: false,
              arrow: false,
              placement: 'bottom',
              content: 'Mark conversation in progress  ⌘⇧🅾'
            }"
          >
            <ion-icon name="arrow-up-outline"></ion-icon>
            <span class="text-with-left-icon hidden-sm">Re-open</span>
          </ion-button>
          <ion-button
            (click)="manuallyShowRightCol = !manuallyShowRightCol"
            [disabled]="isLoadingConversation"
            class="nav-button sidebar-toggle-button"
            color="dark"
            fill="clear"
          >
            <ion-icon
              [name]="manuallyShowRightCol ? 'custom-right-sidebar-active' : 'custom-right-sidebar-inactive'"
            ></ion-icon>
          </ion-button>
        </div>
      </div>
    </ion-toolbar>

    <div class="warning-feature-banner" style="padding: 8px 10px" *ngIf="disableButtons">
      <div class="flex-space-between" style="align-items: center">
        Your trial expired; only limited functionality enabled
        <ion-button color="dark" class="btn-small" [routerLink]="'/upgrade'" [queryParams]="{ plan: 'startup' }">
          <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
          Upgrade account
        </ion-button>
      </div>
    </div>

    <div class="message-list transparent-bg">
      <div class="message-title">
        <div *ngIf="conversation?.resolvedTitle?.length" [innerHTML]="conversation.resolvedTitle"></div>
        <ion-button
          fill="clear"
          class="edit-title-button"
          (click)="editTitle()"
          ngxTippy
          [tippyProps]="{
            touch: false,
            arrow: false,
            placement: 'bottom',
            content: 'Edit title'
          }"
        >
          <ion-icon name="pencil"></ion-icon>
        </ion-button>
      </div>

      <div class="empty-state-container" style="height: 70vh" *ngIf="isInvalidConversation">
        <span class="placeholder-emoji">
          <ion-icon name="file-tray-outline"></ion-icon>
        </span>
        <h1 class="placeholder-title">No conversation found</h1>
        <ion-button fill="clear" routerLink="/dashboard/inbox/me" routerDirection="root">
          Return to the inbox
        </ion-button>
      </div>

      <div
        class="message-list-item"
        *ngFor="let timelineEvent of timelineEvents; let i = index; trackBy: trackByFn"
        [hidden]="
          (!showAuditTrail && timelineEvent.type === 'auditItem') ||
          (!showTriageMessages && getIsPrivateMessage(timelineEvent.data))
        "
        [ngClass]="{
          'audit-item-container': timelineEvent.type === 'auditItem' || timelineEvent.type === 'conversationLink'
        }"
      >
        <ng-container *appVar="timelineEvent.data as data" [ngSwitch]="timelineEvent.type">
          <ng-container *ngSwitchCase="'auditItem'">
            <ng-container *ngIf="data.level === 'high' || showAuditTrailLow">
              <div [ngSwitch]="data.type">
                <span *ngSwitchCase="'created'">
                  <ion-icon name="add-circle-outline" class="audit-icon"></ion-icon>
                  Conversation created
                  <ng-container *ngIf="data.resolvedData?.assignedToUserName">
                    and assigned to {{ data.resolvedData?.assignedToUserName }}
                  </ng-container>
                </span>
                <span *ngSwitchCase="'reassigned'">
                  <ion-icon name="person-add-outline" class="audit-icon"></ion-icon>
                  Conversation reassigned
                  <ng-container *ngIf="data.resolvedData?.assignedToUserName">
                    to {{ data.resolvedData?.assignedToUserName }}
                  </ng-container>
                </span>
                <span *ngSwitchCase="'unassigned'">
                  <ion-icon name="person-remove-outline" class="audit-icon"></ion-icon>
                  Conversation unassigned
                </span>
                <span *ngSwitchCase="'escalated'">
                  <ion-icon name="alert-circle-outline" class="audit-icon"></ion-icon>
                  Conversation escalated
                  <ng-container *ngIf="data.resolvedData?.assignedToUserName">
                    to {{ data.resolvedData?.assignedToUserName }}
                  </ng-container>
                </span>
                <span *ngSwitchCase="'merged'">
                  <ion-icon name="git-merge-outline" class="audit-icon"></ion-icon>
                  Conversation merged
                  <ng-container *ngIf="data.data?.oldConversationFriendlyId">
                    from #{{ data.data?.oldConversationFriendlyId }}
                  </ng-container>
                </span>
                <span *ngSwitchCase="'changed_status'" title="Triggered by {{ data.data?.reason }} ">
                  <ion-icon
                    [name]="
                      data.data.status === 'closed'
                        ? 'checkmark-circle'
                        : data.data.status === 'open'
                          ? 'arrow-up-circle-outline'
                          : data.data.status === 'on_hold'
                            ? 'pause-circle-outline'
                            : 'pulse-outline'
                    "
                    class="audit-icon"
                  ></ion-icon>
                  Conversation status type changed to {{ displayStatus(data.data.status) }}
                </span>
                <span *ngSwitchCase="'changed_sub_status'" title="Triggered by {{ data.data?.reason }} ">
                  <ion-icon
                    [name]="
                      data.data.subStatusKey.startsWith('closed')
                        ? 'checkmark-circle'
                        : data.data.subStatusKey.startsWith('open')
                          ? 'arrow-up-circle-outline'
                          : data.data.subStatusKey.startsWith('on_hold')
                            ? 'pause-circle-outline'
                            : 'pulse-outline'
                    "
                    class="audit-icon"
                  ></ion-icon>
                  Conversation status changed to {{ displaySubStatus(data.data.subStatusKey) }}
                </span>
                <span *ngSwitchCase="'snoozed'">
                  <ion-icon name="alarm-outline" class="audit-icon"></ion-icon>
                  Conversation snoozed</span
                >
                <span *ngSwitchCase="'triaged'" title="Trigger: {{ data.data?.reason }} ">
                  <ion-icon name="swap-horizontal-outline" class="audit-icon"></ion-icon>
                  Conversation triaged
                </span>
                <span *ngSwitchCase="'follower_user_added'">
                  <ion-icon name="person-add-outline" class="audit-icon"></ion-icon>
                  Follower added
                </span>
                <span *ngSwitchCase="'follower_team_added'">
                  <ion-icon name="person-add-outline" class="audit-icon"></ion-icon>
                  Follower team added
                </span>
                <span *ngSwitchCase="'follower_user_removed'">
                  <ion-icon name="person-remove-outline" class="audit-icon"></ion-icon>
                  Follower removed
                </span>
                <span *ngSwitchCase="'follower_team_removed'">
                  <ion-icon name="person-remove-outline" class="audit-icon"></ion-icon>
                  Follower team removed
                </span>
                <span *ngSwitchCase="'response_suggested'">
                  <ion-icon name="sparkles-outline" class="audit-icon"></ion-icon>
                  AI response requested
                </span>
                <span *ngSwitchCase="'widget_continuation_email_sent'">
                  <ion-icon name="mail-outline" class="audit-icon"></ion-icon>
                  {{ data.data.messageCount }} unread message{{ data.data.messageCount === 1 ? '' : 's' }}
                  sent via email
                </span>
                <span *ngSwitchCase="'autoresponder_thumbs_up'">
                  <ion-icon name="thumbs-up-outline" class="audit-icon"></ion-icon>
                  AI autoresponse thumbs up
                </span>
                <span *ngSwitchCase="'autoresponder_thumbs_down'">
                  <ion-icon name="thumbs-down-outline" class="audit-icon"></ion-icon>
                  AI autoresponse thumbs down
                </span>
                <span *ngSwitchCase="'autoresponder_additional_feedback'">
                  <ion-icon name="chatbox-ellipses-outline" class="audit-icon"></ion-icon>
                  AI autoresponse feedback
                </span>
                <span *ngSwitchCase="'approval_request_created'">
                  <ion-icon name="chatbox-ellipses-outline" class="audit-icon"></ion-icon>
                  Approval requested
                </span>
                <span *ngSwitchCase="'approval_request_approved'">
                  <ion-icon name="thumbs-up-outline" class="audit-icon"></ion-icon>
                  Approved
                </span>
                <span *ngSwitchCase="'approval_request_rejected'">
                  <ion-icon name="thumbs-down-outline" class="audit-icon"></ion-icon>
                  Reject
                </span>
                <span *ngSwitchCase="'article_created'">
                  <ion-icon name="book-outline" class="audit-icon"></ion-icon>
                  Knowledge base
                  <a (click)="selectKnowledgeTab(data.data.knowledgeBaseArticleId)">article</a> created
                </span>
                <span *ngSwitchCase="'completed_intake'">
                  <ion-icon name="checkmark-circle-outline" class="audit-icon"></ion-icon>
                  Completed intake
                </span>
                <span *ngSwitchCase="'changed_ticket_type'">
                  <ion-icon name="ticket-outline" class="audit-icon"></ion-icon>
                  Ticket type updated
                </span>
                <span *ngSwitchCase="'changed_ticket_type_fields'">
                  <ion-icon name="ticket-outline" class="audit-icon"></ion-icon>
                  Ticket type fields updated
                </span>
                <span *ngSwitchCase="'changed_priority'">
                  <ion-icon name="alert-circle-outline" class="audit-icon"></ion-icon>
                  Priority updated
                </span>
                <span *ngSwitchCase="'changed_customer'">
                  <ion-icon name="person-outline" class="audit-icon"></ion-icon>
                  Customer updated
                </span>
                <span *ngSwitchCase="'changed_account'">
                  <ion-icon name="person-outline" class="audit-icon"></ion-icon>
                  Account updated
                </span>
                <span *ngIf="data.type === 'autoresponder_additional_feedback'">
                  <br />
                  <i>{{ data.data.feedback }}</i>
                </span>
                <span *ngSwitchCase="'collaborator_user_added'">
                  <ion-icon name="person-add-outline" class="audit-icon"></ion-icon>
                  Collaborator added
                </span>
                <span *ngSwitchCase="'collaborator_team_added'">
                  <ion-icon name="person-add-outline" class="audit-icon"></ion-icon>
                  Collaborator team added
                </span>
                <span *ngSwitchCase="'collaborator_user_removed'">
                  <ion-icon name="person-remove-outline" class="audit-icon"></ion-icon>
                  Collaborator removed
                </span>
                <span *ngSwitchCase="'collaborator_team_removed'">
                  <ion-icon name="person-remove-outline" class="audit-icon"></ion-icon>
                  Collaborator team removed
                </span>
                <span *ngSwitchCase="'escalation_created'">
                  <ion-icon name="alert-circle-outline" class="audit-icon"></ion-icon>
                  Escalation "{{ data.data.title }}" created
                </span>
                <span *ngSwitchCase="'escalation_acknowledged'">
                  <ion-icon name="alert-circle-outline" class="audit-icon"></ion-icon>
                  Escalation "{{ data.data.title }}" acknowledged
                </span>
                <span *ngSwitchCase="'escalation_resolved'">
                  <ion-icon name="alert-circle-outline" class="audit-icon"></ion-icon>
                  <ng-container *ngIf="data.userId === 'system' || !data.resolvedData?.userName">
                    Escalation "{{ data.data.title }}" auto-resolved when conversation was closed
                  </ng-container>
                  <ng-container *ngIf="data.userId !== 'system' && data.resolvedData?.userName">
                    Escalation "{{ data.data.title }}" resolved
                  </ng-container>
                </span>
                <span *ngSwitchCase="'support_step_assigned'">
                  <ion-icon name="timer-outline" class="audit-icon"></ion-icon>
                  SLA step ran
                  {{
                    data.resolvedData?.assignedToUserName
                      ? 'and assigned to ' + data.resolvedData?.assignedToUserName
                      : ''
                  }}
                </span>
                <span
                  *ngSwitchDefault
                  style="text-transform: capitalize"
                  [title]="
                    data.data?.updatedFields?.length ? 'Updated fields: ' + data.data?.updatedFields.join(', ') : ''
                  "
                >
                  <ion-icon name="cloud-done-outline" class="audit-icon"></ion-icon>
                  {{ displayDefaultAuditLogType(data.type) }}
                </span>
                <span *ngIf="data.resolvedData?.userName"> by {{ data.resolvedData?.userName }}</span>
                <span class="hidden-sm" title="{{ data.timestamp | date: 'MMM d yyyy h:mm a' }}">
                  • {{ displayDateFrom(data.timestamp) }}
                </span>
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'conversationLink'">
            <div>
              <ion-icon [name]="data.icon" class="audit-icon"></ion-icon>
              {{ data.label }}
              <div class="message-linked-conversation">
                <app-conversation-chip [conversationId]="data.linkedConversationId"></app-conversation-chip>
              </div>
            </div>
          </ng-container>

          <div *ngSwitchCase="'message'" style="display: flex">
            <div class="message-list-photo">
              <app-avatar
                size="36"
                [ngClass]="{ clickable: !!data.link }"
                [routerLink]="data.link"
                [style.width]="'36px'"
                [style.height]="'36px'"
                [name]="data.name"
                [image]="
                  data.image
                    ? data.image
                    : data.userType === 'bot'
                      ? 'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fai.jpg?alt=media&token=ea532bce-8818-4c86-93b9-3d12ea630313'
                      : null
                "
              >
              </app-avatar>
            </div>
            <div
              class="message-content-container"
              [ngClass]="{ 'message-content-private': getIsPrivateMessage(timelineEvent.data) }"
            >
              <p class="flex-space-between" style="overflow: visible">
                <span class="message-content-label">
                  <strong>
                    <a
                      *ngIf="data.link"
                      [routerLink]="data.link"
                      [ngClass]="{ customer: data.userType !== 'internal' }"
                      >{{ data.name }}</a
                    >
                    <span *ngIf="!data.link">{{ data.name }}</span>

                    <ion-badge color="success" *ngIf="data.userType === 'customer'" class="name-badge">
                      Customer
                    </ion-badge>
                    <ion-badge color="success" *ngIf="data.userType === 'internal_customer'" class="name-badge">
                      Internal Customer
                    </ion-badge>
                    <ion-badge color="dark" *ngIf="data.userType === 'bot'" class="name-badge"> Bot </ion-badge>
                    <span *ngIf="data.type !== 'Slack' && data.userType === 'customer'">
                      <ion-icon
                        name="checkmark-circle"
                        ngxTippy
                        [tippyProps]="{
                          touch: false,
                          arrow: false,
                          placement: 'bottom',
                          content: 'User identity is verified'
                        }"
                        *ngIf="data.isVerified"
                        style="color: var(--ion-color-success)"
                      ></ion-icon>
                      <ion-icon
                        name="warning"
                        ngxTippy
                        [tippyProps]="{
                          touch: false,
                          arrow: false,
                          placement: 'bottom',
                          content: 'Identity of the sender has not been verified'
                        }"
                        *ngIf="!data.isVerified"
                        style="color: #ffae3b"
                      ></ion-icon>
                    </span>
                  </strong>
                  <ng-container *ngIf="data.type !== 'Dashboard'"> • </ng-container>
                  <a
                    (click)="
                      data.triageThread ? openTriageInSlack(data.ts, data.channelId) : openMessageInSlack(data.ts)
                    "
                    style="color: unset"
                  >
                    <ion-icon
                      name="logo-slack"
                      ngxTippy
                      [tippyProps]="{
                        touch: false,
                        arrow: false,
                        allowHTML: true,
                        placement: 'bottom',
                        content: '<strong>Sent via Slack</strong><br/>Click to open in channel'
                      }"
                      *ngIf="data.type === 'Slack'"
                    ></ion-icon>
                    <ion-icon
                      name="mail"
                      ngxTippy
                      [tippyProps]="{
                        touch: false,
                        arrow: false,
                        allowHTML: true,
                        placement: 'bottom',
                        content: '<strong>Sent via Email</strong><br/>Click to open in channel'
                      }"
                      *ngIf="data.type === 'Email'"
                    ></ion-icon>
                    <ion-icon
                      name="chatbubbles"
                      ngxTippy
                      [tippyProps]="{
                        touch: false,
                        arrow: false,
                        allowHTML: true,
                        placement: 'bottom',
                        content: '<strong>Sent via In-App Chat</strong><br/>Click to open in channel'
                      }"
                      *ngIf="data.type === 'Widget'"
                    ></ion-icon>
                    <ion-icon
                      name="custom-teams"
                      ngxTippy
                      [tippyProps]="{
                        touch: false,
                        arrow: false,
                        allowHTML: true,
                        placement: 'bottom',
                        content: '<strong>Sent via Microsoft Teams</strong><br/>Click to open in channel'
                      }"
                      *ngIf="data.type === 'Microsoft Teams'"
                    ></ion-icon>
                    <ion-icon
                      name="logo-slack"
                      ngxTippy
                      [tippyProps]="{
                        touch: false,
                        arrow: false,
                        allowHTML: true,
                        placement: 'bottom',
                        content: '<strong>Sent via Slack Bot DM</strong>'
                      }"
                      *ngIf="data.type === 'Slack Bot DM'"
                    ></ion-icon>
                  </a>
                  <ng-container *ngIf="data.emailId">
                    • <ion-icon name="checkmark"></ion-icon> Email sent
                  </ng-container>
                  <ng-container *ngIf="getIsPrivateMessage(data)"> • Internal message</ng-container>
                  <span *ngIf="data.triageThread">
                    in
                    <a (click)="openTriageInSlack(data.ts, data.channelId)"
                      >#{{ data.triageThread.initialMessage.slackChannel?.name ?? PRIVATE_CHANNEL_NAME }}</a
                    ></span
                  >
                  <span class="hidden-sm" title="{{ data.timestamp | date: 'MMM d yyyy h:mm a' }}">
                    <span class="date-label">{{ displayDateFrom(data.timestamp) }}</span>
                  </span>
                  <ng-container *ngIf="deletingMessageIds.has(data.id)">
                    <ion-spinner name="crescent" style="width: 12px; height: 12px; margin-left: 5px"></ion-spinner>
                    <i>Deleting...</i>
                  </ng-container>
                </span>
                <span *ngIf="!data.deletedAt && getMessageOptions(data).length" class="item-metadata">
                  <ion-button
                    (click)="showMessageOptions(data)"
                    *ngIf="!deletingMessageIds.has(data.id)"
                    color="dark"
                    fill="clear"
                    ngxTippy
                    [tippyProps]="{
                      touch: false,
                      arrow: false,
                      placement: 'top',
                      content: 'Message options'
                    }"
                  >
                    <ion-icon name="ellipsis-vertical-circle"></ion-icon>
                  </ion-button>
                  <ion-button
                    (click)="insertEmoji(data.id)"
                    color="dark"
                    fill="clear"
                    ngxTippy
                    [tippyProps]="{
                      touch: false,
                      arrow: false,
                      placement: 'top',
                      content: 'Add an emoji reaction'
                    }"
                    style="font-size: 0.65rem"
                  >
                    <ion-icon name="custom-add-reaction"></ion-icon>
                  </ion-button>
                </span>
              </p>

              <div *ngIf="data.inbound?.inboundEmail" class="email-recipients-compact">
                <span class="recipient-label">to</span>
                <a
                  class="recipient-list"
                  #popoverTrigger
                  (click)="presentRecipientsPopover($event, data.inbound.inboundEmail)"
                >
                  {{ getCompactRecipientList(data.inbound.inboundEmail) }}
                  <ion-icon name="chevron-down-outline" class="button-icon"></ion-icon>
                </a>
              </div>

              <div *ngIf="data.inbound?.inboundEmail && i === 0" style="font-weight: 600; margin: 3px 0">
                Subject: {{ data.inbound.inboundEmail.subject }}
              </div>

              <!-- Original message content display - now wrapped to be hidden during edit -->
              <div *ngIf="editingMessageId !== data.id">
                <div
                  *ngIf="data.sourceType !== 'slack' && data.sourceType !== 'slack-bot-dm'"
                  [ngClass]="{ 'message-resolved-content': !data.inbound?.inboundEmail }"
                  [innerHTML]="
                    data.inbound?.inboundEmail
                      ? formatEmail(data.inbound.inboundEmail, data.isExpanded)
                      : data.inbound?.microsoftTeamsMessage
                        ? formatMicrosoftTeamsMessage(data.inbound.microsoftTeamsMessage, i)
                        : data.resolvedContent
                  "
                ></div>
                <app-slack-message
                  *ngIf="data.sourceType === 'slack' || data.sourceType === 'slack-bot-dm'"
                  [content]="data.htmlContent"
                ></app-slack-message>
              </div>

              <!-- Inline editor for the message -->
              <div
                *ngIf="editingMessageId === data.id"
                class="inline-editor-container"
                style="width: 100%; max-width: 700px; margin: 0 auto"
              >
                <app-reply-composer
                  #inlineReplyComposerForEdit
                  [isInlineEdit]="true"
                  [conversation]="conversation"
                  [initialContent]="data.htmlContent || data.text"
                  [initialResolvedContent]="data.resolvedContent || []"
                  [showAttachments]="false"
                  [showInternalNoteToggle]="true"
                  [showSendButton]="true"
                  (saveEditClicked)="handleSaveMessageEdit($event, data.id)"
                  (cancelEditClicked)="handleCancelMessageEdit()"
                  style="width: 100%"
                ></app-reply-composer>
              </div>

              <div *ngIf="data.aiThoughts">
                <div *ngIf="data.aiThoughts.length === 0" class="thoughts-not-available-message-container">
                  <p>Thoughts are not available for this message</p>
                </div>
                <ng-container *ngIf="data.aiThoughts && data.aiThoughts.length">
                  <ion-accordion-group class="show-thoughts-accordion-group" value="show thinking">
                    <ion-accordion class="show-thoughts-accordion" value="show thinking">
                      <ion-item slot="header" class="accordion-header">
                        <p><strong>Show Thinking</strong></p>
                        <ion-icon
                          style="height: 1rem"
                          name="warning-outline"
                          color="warning"
                          *ngIf="data.aiThoughtsShowLowConfidence"
                          ngxTippy="Warning: Some of the thoughts have low confidence scores"
                        ></ion-icon>
                      </ion-item>
                      <ion-card slot="content" class="outline-card embedded-card-content">
                        <ion-item *ngFor="let thought of data.aiThoughts; let i = index">
                          <ion-label>
                            <h3>{{ i + 1 }}. {{ thought.subject }}</h3>
                            <p class="thought-result">{{ thought.result }}</p>
                            <ng-container *ngIf="getObjectEntries(thought.aspects).length">
                              <ion-button
                                expand="block"
                                fill="clear"
                                (click)="thought.showThoughtAspects = !thought.showThoughtAspects"
                                style="margin: 20px 0"
                              >
                                <ion-icon
                                  [name]="thought.showThoughtAspects ? 'chevron-up-outline' : 'chevron-down-outline'"
                                  class="padded-icon"
                                ></ion-icon>
                                Show More Details
                              </ion-button>
                              <ng-container *ngIf="thought.showThoughtAspects">
                                <ion-grid>
                                  <ion-row *ngFor="let aspect of getObjectEntries(thought.aspects)">
                                    <ng-container
                                      *ngIf="thought.aspects.aspect_format === ASPECT_FORMATS.KB_SEARCH_RESULTS"
                                    >
                                      <ng-container *ngFor="let searchResult of thought.aspects.all_search_results">
                                        <ion-col size="6">
                                          <p>Relevance score: {{ searchResult.score }}</p>
                                        </ion-col>
                                        <ion-col size="6">
                                          <p style="margin: 5px 0px">
                                            <a [href]="searchResult.url">{{ searchResult.title }}</a>
                                          </p>
                                        </ion-col>
                                      </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="!thought.aspects.aspect_format">
                                      <ion-col>
                                        <p>{{ aspect.key }}</p>
                                      </ion-col>
                                      <ion-col>
                                        <p>{{ aspect.value }}</p>
                                      </ion-col>
                                    </ng-container>
                                  </ion-row>
                                </ion-grid>
                              </ng-container>
                            </ng-container>
                          </ion-label>
                        </ion-item>
                      </ion-card>
                    </ion-accordion>
                  </ion-accordion-group>
                </ng-container>
              </div>
              <span *ngIf="data.deletedAt && editingMessageId !== data.id" style="opacity: 0.5">
                <ion-icon name="trash-outline" class="padded-icon"></ion-icon>This message was deleted
              </span>
              <div *ngIf="data.inbound?.widgetMessage?.attachments?.length" class="flexed">
                <app-inline-file-attachment
                  *ngFor="let attachment of data.inbound.widgetMessage.attachments; let i = index"
                  [id]="attachment.id ?? attachment.slackId"
                  [teamId]="conversation.slackChannel?.teamId"
                  [size]="160"
                  [attachments]="data.inbound.widgetMessage.attachments"
                  [attachmentsIdKey]="attachment.id ? 'id' : 'slackId'"
                  [attachmentsIndex]="i"
                  [onError]="createFileAttachmentErrorHandler(data.ts)"
                  [conversationId]="conversation.id"
                />
              </div>
              <div *ngIf="data.inbound?.inboundEmail?.attachments?.length" class="flexed">
                <app-inline-file-attachment
                  *ngFor="let attachment of data.inbound.inboundEmail.attachments; let i = index"
                  [id]="attachment.id ?? attachment.slackId"
                  [teamId]="conversation.slackChannel?.teamId"
                  [size]="160"
                  [attachments]="data.inbound.inboundEmail.attachments"
                  [attachmentsIdKey]="attachment.id ? 'id' : 'slackId'"
                  [attachmentsIndex]="i"
                  [onError]="createFileAttachmentErrorHandler(data.ts)"
                  [conversationId]="conversation.id"
                />
              </div>
              <div *ngIf="data.files?.length && !data.inbound?.inboundEmail?.attachments?.length" class="flexed">
                <app-inline-file-attachment
                  *ngFor="let file of data.files; trackBy: fileTrackBy; let i = index"
                  [id]="file.id"
                  [mimetype]="file.mimetype"
                  [privateUrl]="file.urlPrivate"
                  [teamId]="conversation.slackChannel?.teamId"
                  [size]="160"
                  [attachments]="data.files"
                  attachmentsIdKey="id"
                  [attachmentsIndex]="i"
                  [onError]="createFileAttachmentErrorHandler(data.ts)"
                  [conversationId]="conversation.id"
                />
              </div>

              <div *ngIf="slackAttachments[data.id]" class="flexed">
                <app-inline-file-attachment
                  *ngFor="let attachment of slackAttachments[data.id]; let i = index"
                  [id]="attachment.slackId"
                  [teamId]="conversation.slackChannel?.teamId"
                  [size]="160"
                  [attachments]="slackAttachments[data.id]"
                  attachmentsIdKey="slackId"
                  [attachmentsIndex]="i"
                  [onError]="createFileAttachmentErrorHandler(data.ts)"
                  [conversationId]="conversation.id"
                />
              </div>

              <div
                *ngIf="data.type === 'Email'"
                style="
                  width: 100%;
                  border-top: 1px solid var(--ion-subtle-border-color);
                  padding-top: 8px;
                  margin-top: 7px;
                  font-weight: 500;
                  font-size: 0.8rem;
                "
              >
                <a (click)="data.isExpanded = !data.isExpanded">
                  <ion-icon [name]="data.isExpanded ? 'remove-outline' : 'add-outline'"> </ion-icon>
                  {{ data.isExpanded ? 'Collapse' : 'Expand' }}
                </a>
              </div>

              <div
                style="display: flex; align-items: center; margin-top: 6px"
                *ngIf="!data.deletedAt && data.reactions?.length"
              >
                <ion-chip
                  class="send-emoji-reaction"
                  [color]="currentUserAddedReaction(reaction) ? 'primary' : 'dark'"
                  *ngFor="let reaction of data.reactions; trackBy: emojiReactionsTrackBy"
                  (click)="changeReaction(data.id, reaction)"
                  [ngClass]="{
                    'current-user-added': currentUserAddedReaction(reaction),
                    'cannot-edit-emojis': !hasUserReactionsWriteScope
                  }"
                  ngxTippy
                  [tippyProps]="
                    emojiReactionTooltipProps[data.id + '::' + reaction.name] || {
                      touch: false,
                      arrow: false,
                      placement: 'top',
                      content: 'Add an emoji reaction'
                    }
                  "
                >
                  <ng-container *appVar="getReactionEmoji(reaction.name) as reactionEmoji">
                    <span *ngIf="!reactionEmoji.startsWith('https://')">{{ reactionEmoji }}</span>
                    <span
                      *ngIf="reactionEmoji.startsWith('https://')"
                      [ngStyle]="{ 'background-image': 'url(' + reactionEmoji + ')' }"
                      style="
                        background-repeat: no-repeat;
                        background-size: cover;
                        background-color: #efefff;
                        background-position: center;
                        width: 15px;
                        height: 15px;
                      "
                    ></span>
                  </ng-container>
                  <span *ngIf="reaction.count > 1" style="font-size: 0.75rem; margin-left: 2px">
                    {{ reaction.count }}
                  </span>
                </ion-chip>
                <ion-chip
                  class="send-emoji-reaction"
                  color="dark"
                  (click)="insertEmoji(data.id)"
                  style="background: transparent"
                  ngxTippy
                  [tippyProps]="{
                    touch: false,
                    arrow: false,
                    placement: 'top',
                    content: 'Add an emoji reaction'
                  }"
                >
                  <ion-icon name="custom-add-reaction" style="margin: 0 4px; font-size: 0.9rem"></ion-icon>
                </ion-chip>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div
        *ngFor="let pendingMessage of getPendingMessages(); trackBy: pendingMessagesTrackBy"
        class="message-list-item"
        style="display: flex"
      >
        <div class="message-list-photo">
          <img
            [src]="
              authService.userPhoto ||
              'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fuser-blank%402x.png?alt=media&token=c06cd4ba-188a-436d-a691-72d469a0e8a5'
            "
          />
        </div>
        <div
          class="message-content-container"
          [ngClass]="{ 'message-content-private': pendingMessage.isPrivateExplanation }"
        >
          <p class="flex-space-between">
            <span class="message-content-label">
              <strong> {{ authService.user?.displayName }} </strong> •
              <ion-spinner name="crescent" style="width: 12px; height: 12px; margin: 0 5px"></ion-spinner>
              <i>Sending...</i>
            </span>
          </p>
          <div
            class="message-resolved-content"
            [innerHTML]="pendingMessage.content | safeHtml"
            style="font-size: 0.86rem"
          ></div>
          <div *ngIf="pendingMessage.attachments?.length" style="display: flex">
            <app-inline-file-attachment
              *ngFor="let attachment of pendingMessage.attachments"
              [file]="attachment"
              [teamId]="conversation.slackChannel?.teamId"
              [size]="160"
              [conversationId]="conversation.id"
            />
          </div>
        </div>
      </div>

      <div
        *ngIf="timelineEvents?.length && conversation?.status === 'closed' && !conversation?.knowledgeBaseArticle"
        class="message-list-item audit-item-container"
      >
        <ion-button
          fill="clear"
          color="dark"
          (click)="getArticleSuggestion()"
          style="margin: 5px 0 0 23px"
          class="btn-small button-dark-border"
        >
          <ion-icon name="sparkles-outline" style="padding-right: 6px"></ion-icon>
          Suggestion: Create knowledge base article...
        </ion-button>
      </div>
    </div>

    <div class="compose-container" [hidden]="!timelineEvents?.length">
      <app-reply-composer
        #composer
        *ngIf="conversation"
        [conversation]="conversation"
        [timelineEvents]="timelineEvents"
        [hasUserChatWriteScope]="hasUserChatWriteScope"
        [hasUserFilesWriteScope]="hasUserFilesWriteScope"
        [hasTenantFilesWriteScope]="hasTenantFilesWriteScope"
        [connectUserToSlack]="connectUserToSlack"
        (didSendPendingMessage)="composerDidSendPendingMessage($event)"
        (didInsertKnowledgebaseArticle)="composerDidInsertKnowledgebaseArticle($event)"
        (didRunAutomation)="composerDidRunAutomation($event)"
        (didSendTestEmail)="sendTestEmailToSelf($event)"
        [repliesDisabled]="wasManuallySplit"
      ></app-reply-composer>
    </div>

    <ion-modal [isOpen]="showEmailHtmlModal" (willDismiss)="onDismissEmailHtmlModal()" class="email-html-modal">
      <ng-template>
        <ion-header>
          <ion-toolbar>
            <ion-title><b>Subject:</b> {{ inboundEmail.subject }}</ion-title>
            <ion-buttons slot="end">
              <ion-button (click)="showEmailHtmlModal = false">Close</ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
          <div [innerHTML]="inboundEmail.htmlContent"></div>
        </ion-content>
      </ng-template>
    </ion-modal>
  </ion-content>
</div>

<div class="right-col" [ngClass]="{ 'show-right-col-override': manuallyShowRightCol }">
  <ion-toolbar class="sticky-toolbar">
    <div class="toolbar-container">
      <div class="flexed header-container">
        <span
          class="tab-nav-link"
          [ngClass]="{ 'tab-nav-active': sidebarTab === 'details' }"
          (click)="sidebarTab = 'details'"
        >
          Details
        </span>
        <span
          class="tab-nav-link"
          [ngClass]="{ 'tab-nav-active': sidebarTab === 'knowledge' }"
          (click)="selectKnowledgeTab()"
        >
          Knowledge
        </span>
      </div>
    </div>
  </ion-toolbar>
  <div style="padding: 20px" *ngIf="!conversation">
    <ion-skeleton-text
      [animated]="!isInvalidConversation"
      style="height: 44px; width: 44px; margin: 0"
    ></ion-skeleton-text>
    <ion-skeleton-text [animated]="!isInvalidConversation" style="width: 80%; margin: 40px 0"></ion-skeleton-text>
    <ion-skeleton-text [animated]="!isInvalidConversation" style="width: 80%; margin: 40px 0"></ion-skeleton-text>
    <ion-skeleton-text [animated]="!isInvalidConversation" style="width: 80%; margin: 40px 0"></ion-skeleton-text>
    <ion-skeleton-text [animated]="!isInvalidConversation" style="width: 80%; margin: 40px 0"></ion-skeleton-text>
  </div>
  <div *ngIf="conversation">
    <div [hidden]="sidebarTab === 'knowledge'">
      <app-conversation-info [conversation]="conversation"></app-conversation-info>

      <ion-list class="transparent-bg no-padding" lines="none" style="margin-top: 5px">
        <ion-item *ngIf="conversation.summary && authService.isAiFeatureEnabled('autoSummarize')">
          <ion-label text-wrap>
            <p>
              Summary
              <span
                ngxTippy
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  content: 'Generated by AI'
                }"
                >✨</span
              >
            </p>
            {{ conversation.summary }}
          </ion-label>
        </ion-item>
        <ion-item *ngIf="conversation.status === 'on_hold' && conversation.wakeUpAt">
          <ion-label
            text-wrap
            style="padding: 8px; border-radius: 6px; font-size: 0.75rem; background: var(--ion-color-step-50)"
          >
            {{ displaySnooze() }}
          </ion-label>
        </ion-item>

        <ion-item class="align-top">
          <ion-label slot="start">
            <p>Status</p>
          </ion-label>
          <ion-chip
            mode="ios"
            class="select-chip select-outline"
            [outline]="true"
            [disabled]="disableButtons"
            (click)="showSubStatusOptions($event)"
          >
            <ion-label>
              <ion-icon
                [name]="STATUS_COLUMN_FORMAT_MAP[conversation.status].icon"
                [class]="STATUS_COLUMN_FORMAT_MAP[conversation.status].iconClass"
                style="margin-right: 5px"
              ></ion-icon>
              {{ conversation.subStatus?.name ?? 'None' }}
              <ion-icon name="chevron-down-outline" class="icon-padded-left chevron-icon"></ion-icon>
            </ion-label>
          </ion-chip>
        </ion-item>

        <ion-item class="align-top">
          <ion-label slot="start">
            <p>Assignee</p>
          </ion-label>
          <ion-chip
            mode="ios"
            class="select-chip select-outline"
            [outline]="true"
            [disabled]="disableButtons"
            (click)="showAssigneeOptions($event)"
            ngxTippy
            [tippyProps]="{
              touch: false,
              arrow: false,
              placement: 'bottom',
              content: 'Change assignee (Shift + 🅰)'
            }"
          >
            <app-avatar
              *ngIf="conversation.assignedToUser"
              size="22"
              [style.height]="'20px'"
              [style.width]="'20px'"
              [style.margin]="'0 6px 0 -5px'"
              [name]="conversation.assignedToUser.name"
              [image]="conversation.assignedToUser.photo"
            >
            </app-avatar>
            <ion-label>
              {{ conversation.assignedToUser?.name ?? 'None' }}
              <ion-icon name="chevron-down-outline" class="icon-padded-left chevron-icon"></ion-icon>
            </ion-label>
          </ion-chip>
        </ion-item>

        <ion-item class="align-top" *ngFor="let collaboratorType of collaboratorTypes">
          <ion-label slot="start">
            <p>{{ collaboratorType.name }}</p>
          </ion-label>
          <ion-chip
            mode="ios"
            class="select-chip select-outline"
            [outline]="true"
            [disabled]="disableButtons"
            (click)="showCollaboratorOptions(collaboratorType.id)"
          >
            <app-avatar
              *ngIf="collaborators[collaboratorType.id]?.user"
              size="22"
              [style.height]="'22px'"
              [style.width]="'22px'"
              [style.margin]="'0 5px 0 -5px'"
              [name]="collaborators[collaboratorType.id].user.name"
              [image]="collaborators[collaboratorType.id].user.photo"
            >
            </app-avatar>
            <app-avatar
              *ngIf="collaborators[collaboratorType.id]?.group"
              size="22"
              [style.height]="'22px'"
              [style.width]="'22px'"
              [style.margin]="'0 5px 0 -5px'"
              [name]="collaborators[collaboratorType.id].group.name"
              [image]="collaborators[collaboratorType.id].group.photo"
            >
            </app-avatar>
            <ion-label>
              {{
                collaborators[collaboratorType.id]?.user?.name ??
                  collaborators[collaboratorType.id]?.group?.name ??
                  'None'
              }}
              <ion-icon name="chevron-down-outline" class="icon-padded-left chevron-icon"></ion-icon>
            </ion-label>
          </ion-chip>
        </ion-item>

        <ion-item class="align-top">
          <ion-label slot="start">
            <p>Followers</p>
          </ion-label>
          <ion-label text-wrap style="margin: 6px 0">
            <ion-chip
              mode="ios"
              color="dark"
              class="chip tag-chip tag-chip-light"
              [disabled]="disableButtons"
              style="margin: 0 7px"
              *ngFor="let follower of conversation.followers || []"
              (click)="showFollowerOptions(follower.entityId)"
            >
              <ion-label> {{ follower.user?.name ?? follower.group?.name }} </ion-label>
            </ion-chip>
            <ion-chip
              mode="ios"
              [outline]="true"
              [disabled]="disableButtons"
              class="chip"
              (click)="addFollower($event)"
              ngxTippy
              [tippyProps]="{
                touch: false,
                arrow: false,
                placement: 'bottom',
                content: 'Add follower to conversation'
              }"
            >
              <ion-label>
                <span *ngIf="conversation.followers?.length">Add...</span>
                <span *ngIf="!conversation.followers?.length">Add follower...</span>
              </ion-label>
            </ion-chip>
          </ion-label>
        </ion-item>

        <ion-item class="align-top">
          <ion-label slot="start">
            <p>Priority</p>
          </ion-label>
          <ion-chip
            mode="ios"
            class="select-chip select-outline"
            [outline]="true"
            [disabled]="disableButtons"
            (click)="showPriorityOptions()"
            ngxTippy
            [tippyProps]="{
              touch: false,
              arrow: false,
              placement: 'bottom',
              content: 'Change priority (Shift + 🅿)'
            }"
          >
            <ion-label>
              <ion-text [color]="getColorForPriority(conversation.priority)">
                <ion-icon
                  [name]="getIconForPriority(conversation.priority)"
                  *ngIf="conversation.priority && !displayPriorityEmoji(conversation.priority)"
                  style="margin-right: 5px"
                ></ion-icon>
                <ng-container *ngIf="displayPriorityEmoji(conversation.priority) | colonToEmoji as emojiString">
                  <img
                    *ngIf="isURL(emojiString)"
                    [src]="emojiString"
                    alt="Priority Emoji"
                    style="width: 1em; height: 1em; vertical-align: -0.125em; margin-right: 0.075em"
                  />
                  <span *ngIf="!isURL(emojiString)" style="margin-right: 5px">{{ emojiString }}</span>
                </ng-container>
              </ion-text>
              {{ displayPriority() }}
              <ion-icon name="chevron-down-outline" class="icon-padded-left chevron-icon"></ion-icon>
            </ion-label>
          </ion-chip>
        </ion-item>

        <ion-item class="align-top">
          <ion-label slot="start">
            <p>Ticket type</p>
          </ion-label>
          <ion-chip
            mode="ios"
            class="select-chip select-outline"
            [outline]="true"
            (click)="showTicketTypeOptions()"
            [disabled]="disableButtons"
          >
            <ion-label>
              {{ conversation.ticketType?.name ?? 'None' }}
              <ion-icon name="chevron-down-outline" class="icon-padded-left chevron-icon"></ion-icon>
            </ion-label>
          </ion-chip>
        </ion-item>

        <div>
          <app-ticket-type-fields
            *ngIf="allFieldDefinitions.length > 0"
            [fieldDefinitions]="allFieldDefinitions"
            [fieldValues]="conversation.ticketTypeFields"
            [fieldMetadata]="conversation.ticketFieldMetadata"
            (fieldValuesChange)="onFieldValuesUpdate($event)"
            [conversationId]="conversationId"
            [disabled]="isLoadingConversation || disableButtons"
            [projectId]="conversation.projectId"
            [ticketTypeId]="conversation.ticketType?.id"
          ></app-ticket-type-fields>
        </div>

        <ion-item class="align-top">
          <ion-label slot="start">
            <p>Triaged to</p>
          </ion-label>
          <ion-label text-wrap style="margin: 6px 0">
            <ion-chip
              mode="ios"
              color="dark"
              class="chip"
              [disabled]="disableButtons"
              style="background: transparent"
              *ngFor="let triage of filteredTriageMessages()"
              (click)="openTriageInSlack(triage.ts, triage.channelId)"
            >
              <ion-label>
                <ion-icon name="logo-slack"></ion-icon>
                {{ triage.channelName ?? PRIVATE_CHANNEL_NAME }}
              </ion-label>
            </ion-chip>
            <ion-chip
              mode="ios"
              class="chip"
              [outline]="true"
              (click)="triage()"
              [disabled]="disableButtons"
              ngxTippy
              [tippyProps]="{
                touch: false,
                arrow: false,
                placement: 'bottom',
                content: 'Create a private side discussion in an internal channel'
              }"
            >
              <ion-label>
                {{ conversation.triageThreads?.length ? 'Add...' : 'Create triage thread...' }}
              </ion-label>
            </ion-chip>
          </ion-label>
        </ion-item>
        <ion-item *ngIf="conversation.externalSupportMetadata?.url" class="align-top">
          <ion-label slot="start">
            <p style="text-transform: capitalize">{{ conversation.externalSupportMetadata?.type }}</p>
          </ion-label>
          <ion-label text-wrap style="margin: 6px 0">
            <ion-chip
              mode="ios"
              color="primary"
              class="chip"
              [disabled]="disableButtons"
              style="background: transparent"
              (click)="openExternalTicket()"
            >
              <ion-label>
                <ion-icon name="ticket-outline"></ion-icon>
                View ticket
              </ion-label>
            </ion-chip>
          </ion-label>
        </ion-item>
        <ion-item class="align-top">
          <ion-label slot="start">
            <p>Tags</p>
          </ion-label>
          <ion-label text-wrap style="margin: 6px 0">
            <ion-chip
              mode="ios"
              color="primary"
              class="chip tag-chip"
              [disabled]="disableButtons"
              *ngFor="let tag of tags"
              (click)="showTagOption(tag)"
              style="margin-left: 4px"
            >
              <ion-label> {{ tag.tag.name }}{{ tag.isAutoApplied && !tag.isExample ? ' ✨' : '' }} </ion-label>
            </ion-chip>
            <ion-chip
              mode="ios"
              [outline]="true"
              [disabled]="disableButtons"
              class="chip"
              (click)="addTag($event)"
              ngxTippy
              [tippyProps]="{
                touch: false,
                arrow: false,
                placement: 'bottom',
                content: 'Add tag (Shift + 🆃)'
              }"
            >
              <ion-label>
                <span *ngIf="tags?.length">Add...</span>
                <span *ngIf="!tags?.length">Add tag...</span>
              </ion-label>
            </ion-chip>
          </ion-label>
        </ion-item>
        <ion-item class="align-top">
          <ion-label text-wrap slot="start">
            <p>Notes</p>
          </ion-label>
          <ion-label text-wrap style="margin: 0">
            <ion-textarea
              [disabled]="disableButtons"
              [(ngModel)]="conversation.notes"
              autoGrow="true"
              placeholder="Add any notes here"
              (ionBlur)="didBlurNotes()"
              class="right-col-input-wrapper"
            ></ion-textarea>
          </ion-label>
        </ion-item>
      </ion-list>

      <ion-accordion-group
        [value]="openEscalationsAccordions"
        *ngIf="conversation && authService.tenant.featureFlags.escalationsEnabled"
        class="accordion-container"
      >
        <ion-accordion value="escalations">
          <ion-item slot="header" style="padding: 0" (click)="getEscalations()">
            <ion-label class="step-label"> Escalations </ion-label>
          </ion-item>
          <div class="step-content" slot="content">
            <div *ngIf="isLoadingEscalations" style="text-align: center; padding-top: 20px; opacity: 0.6">
              <ion-spinner name="crescent"></ion-spinner>
            </div>
            <div
              *ngIf="!isLoadingEscalations && !escalations?.length"
              style="text-align: center; padding: 20px 0; opacity: 0.35; font-size: 0.8rem; font-weight: 600"
            >
              <ion-icon name="file-tray-outline" class="padded-icon"></ion-icon>No escalations found
            </div>
            <ion-card
              *ngFor="let escalation of escalations"
              class="convo-card bordered-card"
              style="margin: 5px 15px 10px 15px; padding: 10px 10px 7px 10px"
            >
              <div style="margin-bottom: 5px; font-size: 0.7rem; opacity: 0.8">
                <span>{{ escalation.escalationType?.name }}</span>
                <span *ngIf="escalation.triageThread?.initialMessage">
                  in
                  <a
                    (click)="
                      openTriageInSlack(
                        escalation.triageThread.initialMessage.ts,
                        escalation.triageThread.initialMessage.channelId
                      )
                    "
                    >#{{ escalation.triageThread?.initialMessage?.slackChannel?.name ?? PRIVATE_CHANNEL_NAME }}</a
                  >
                </span>
              </div>

              <p class="title-text" style="margin: 5px 0 8px 0; font-size: 0.8rem; font-weight: 500">
                {{ escalation.title }}
              </p>
              <!-- <div
                *ngIf="escalation.body"
                [innerHTML]="escalation.body | safeHtml"
                style="font-size: 0.8rem; margin-bottom: 8px"
              ></div> -->
              <div class="flex-space-between bottom-section">
                <div style="display: flex; align-items: center; justify-content: flex-start; width: 50%; gap: 8px">
                  <div style="margin: 0; padding: 0; margin-right: -8px">
                    <div
                      *ngIf="escalation.status === ESCALATION_STATUSES.PENDING"
                      class="status-label status-label-needs-response clickable"
                      ngxTippy
                      data-tippy-content="Pending"
                      (click)="changeEscalationStatus(escalation, $event)"
                    >
                      <ion-icon name="custom-open"></ion-icon>
                    </div>
                    <div
                      *ngIf="escalation.status === ESCALATION_STATUSES.ACKNOWLEDGED"
                      class="status-label status-label-in-progress clickable"
                      ngxTippy
                      data-tippy-content="Acknowledged"
                      (click)="changeEscalationStatus(escalation, $event)"
                    >
                      <ion-icon name="custom-in-progress"></ion-icon>
                    </div>
                    <div
                      *ngIf="escalation.status === ESCALATION_STATUSES.RESOLVED"
                      class="status-label status-label-closed clickable"
                      ngxTippy
                      data-tippy-content="Resolved"
                      (click)="changeEscalationStatus(escalation, $event)"
                    >
                      <ion-icon name="custom-closed"></ion-icon>
                    </div>
                  </div>

                  <div
                    class="clickable"
                    (click)="changeEscalationAssignee(escalation, $event)"
                    style="margin: 0; padding: 0"
                  >
                    <ion-icon
                      name="people"
                      style="opacity: 0.7"
                      [ngxTippy]="
                        escalation.assignedToGroup ? 'Assigned to ' + escalation.assignedToGroup.name : 'Unassigned'
                      "
                    ></ion-icon>
                  </div>

                  <div
                    class="clickable"
                    (click)="
                      escalation.assignedToGroupId
                        ? promptForUserInGroup(escalation, escalation.assignedToGroupId, $event)
                        : changeEscalationAssignee(escalation, $event)
                    "
                    style="margin: 0; padding: 0; display: flex; align-items: center"
                  >
                    <app-avatar
                      size="20"
                      *ngIf="escalation.assignedToUser"
                      [style.width]="'18px'"
                      [style.min-width]="'18px'"
                      [style.height]="'18px'"
                      [name]="escalation.assignedToUser.name"
                      [image]="escalation.assignedToUser.photo"
                      [ngxTippy]="'Assigned to ' + escalation.assignedToUser.name"
                    >
                    </app-avatar>
                    <ion-icon
                      name="person"
                      *ngIf="!escalation.assignedToUser"
                      style="opacity: 0.7"
                      [ngxTippy]="'Unassigned'"
                    ></ion-icon>
                  </div>

                  <div style="margin: 0; padding: 0">
                    <div
                      *ngIf="escalation.priority"
                      class="tag-accessory clickable"
                      ngxTippy
                      [attr.data-tippy-content]="priorityValueToTokenMap[escalation.priority]?.LABEL"
                      (click)="changeEscalationPriority(escalation, $event)"
                    >
                      <ion-icon
                        [name]="getIconForPriority(escalation.priority)"
                        *ngIf="!displayPriorityEmoji(escalation.priority)"
                        style="margin-right: 5px"
                      ></ion-icon>
                      <ng-container *ngIf="displayPriorityEmoji(escalation.priority) | colonToEmoji as emojiString">
                        <img
                          *ngIf="isURL(emojiString)"
                          [src]="emojiString"
                          alt="Priority Emoji"
                          style="width: 1em; height: 1em; vertical-align: -0.125em; margin-right: 0.075em"
                        />
                        <span *ngIf="!isURL(emojiString)" style="margin-right: 5px">{{ emojiString }}</span>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="date">
                  {{ displayDateFrom(escalation.createdAt) }}
                </div>
              </div>
            </ion-card>
            <ion-list lines="none" class="no-padding">
              <ion-item>
                <ion-button
                  (click)="openCreateEscalationModal()"
                  color="light"
                  class="no-margin"
                  [disabled]="disableButtons"
                >
                  <ion-icon name="add-circle" class="padded-icon"></ion-icon>Create escalation...
                </ion-button>
                <ion-button
                  fill="clear"
                  color="dark"
                  (click)="getEscalations(true)"
                  style="margin-left: 6px"
                  class="refresh-button"
                >
                  <ion-icon name="refresh-outline"></ion-icon>
                </ion-button>
              </ion-item>
            </ion-list>
          </div>
        </ion-accordion>
      </ion-accordion-group>

      <ion-accordion-group
        [value]="openTaskAccordions"
        *ngIf="conversation && taskManagerName"
        class="accordion-container"
      >
        <ion-accordion value="tasks">
          <ion-item slot="header" style="padding: 0">
            <ion-label class="step-label"> {{ taskManagerName }} Tasks </ion-label>
          </ion-item>
          <div class="step-content" slot="content">
            <ion-list lines="none" class="no-padding">
              <ion-item *ngFor="let task of conversation.externalTasks">
                <ion-text
                  color="warning"
                  style="margin: -1px 8px 0px 1px"
                  *ngIf="!task.isCompleted"
                  ngxTippy
                  [tippyProps]="{
                    touch: false,
                    arrow: false,
                    placement: 'bottom',
                    content: 'Todo'
                  }"
                >
                  <ion-icon name="custom-in-progress"></ion-icon>
                </ion-text>
                <ion-text
                  color="success"
                  style="margin: -1px 8px 0px 1px"
                  *ngIf="task.isCompleted"
                  ngxTippy
                  [tippyProps]="{
                    touch: false,
                    arrow: false,
                    placement: 'bottom',
                    content: 'Done'
                  }"
                >
                  <ion-icon name="checkmark-circle"></ion-icon>
                </ion-text>
                <ion-label text-wrap>
                  <a
                    href="{{ task.url }}"
                    target="_blank"
                    [ngClass]="{ 'completed-task': task.isCompleted }"
                    style="color: var(--ion-text-color)"
                  >
                    {{ task.friendlyId ? task.friendlyId + ' - ' : '' }}{{ task.name }}
                  </a>
                  <span class="clickable" (click)="showTaskOptions(task.id)">
                    <ion-icon name="ellipsis-horizontal"></ion-icon>
                  </span>
                </ion-label>
              </ion-item>
            </ion-list>
            <ion-list class="no-padding" lines="none">
              <ion-item>
                <ion-button
                  (click)="createTask()"
                  color="light"
                  [disabled]="disableButtons"
                  *ngIf="taskManagerSupportsCreation()"
                  class="no-margin"
                >
                  <ion-icon name="add-circle" class="padded-icon"></ion-icon>Create task
                </ion-button>
                <ion-button
                  (click)="linkExternalTask()"
                  color="light"
                  style="margin: 0 5px"
                  [disabled]="disableButtons"
                >
                  <ion-icon name="link-outline" class="padded-icon"></ion-icon>
                  Link existing
                </ion-button>
                <ion-button
                  fill="clear"
                  color="dark"
                  (click)="loadTasks()"
                  class="no-margin"
                  [disabled]="isLoadingTasks"
                  class="refresh-button"
                >
                  <ion-spinner name="crescent" *ngIf="isLoadingTasks" style="width: 16px"></ion-spinner>
                  <ion-icon name="refresh-outline" *ngIf="!isLoadingTasks"></ion-icon>
                </ion-button>
              </ion-item>
            </ion-list>
          </div>
        </ion-accordion>
      </ion-accordion-group>

      <ion-accordion-group [value]="openApprovalRequestsAccordions" *ngIf="conversation" class="accordion-container">
        <ion-accordion value="approvalRequests">
          <ion-item slot="header" style="padding: 0">
            <ion-label class="step-label"> Approval Requests </ion-label>
          </ion-item>
          <div class="step-content" slot="content">
            <ion-card class="outline-card" style="margin: 5px 15px" *ngIf="approvalRequests?.length">
              <ion-list lines="none" class="no-padding">
                <ion-item class="no-padding" *ngFor="let approvalRequest of approvalRequests">
                  <ion-icon
                    slot="start"
                    name="checkmark-circle"
                    class="automation-left-icon"
                    style="color: var(--ion-color-success)"
                    *ngIf="approvalRequest.status === 'approved'"
                  ></ion-icon>
                  <ion-icon
                    slot="start"
                    name="close-circle"
                    class="automation-left-icon"
                    style="color: var(--ion-color-danger)"
                    *ngIf="approvalRequest.status === 'rejected'"
                  ></ion-icon>
                  <ion-icon
                    slot="start"
                    name="ellipsis-horizontal-circle"
                    class="automation-left-icon"
                    style="color: var(--ion-color-warning)"
                    *ngIf="approvalRequest.status === 'pending'"
                  ></ion-icon>
                  <ion-label text-wrap>
                    <h3>{{ approvalRequest.title }}</h3>
                    <p>
                      <span style="text-transform: capitalize; margin-right: 3px; font-weight: 500">
                        {{ approvalRequest.status }}
                      </span>
                      {{ getApprovalRequestLabel(approvalRequest) }}
                    </p>
                    <p *ngIf="approvalRequest.notes">
                      <em>Comments: {{ approvalRequest.notes }}</em>
                    </p>
                  </ion-label>

                  <ion-button
                    *ngIf="approvalRequest.status === 'pending'"
                    (click)="showApprovalRequestItemActions(approvalRequest)"
                    class="nav-button"
                    color="dark"
                    [disabled]="disableButtons"
                    fill="clear"
                    ngxTippy
                    [tippyProps]="{
                      touch: false,
                      arrow: false,
                      placement: 'bottom',
                      content: 'Show approval request actions'
                    }"
                  >
                    <ion-icon name="ellipsis-horizontal"></ion-icon>
                  </ion-button>
                </ion-item>
              </ion-list>
            </ion-card>
            <ion-list lines="none" class="no-padding">
              <ion-item>
                <ion-button
                  (click)="openCreateApprovalRequestModal()"
                  color="light"
                  class="no-margin"
                  [disabled]="disableButtons"
                >
                  <ion-icon name="add-circle" class="padded-icon"></ion-icon>Request approval...
                </ion-button>
                <ion-button
                  fill="clear"
                  color="dark"
                  (click)="loadApprovalRequestData()"
                  style="margin-left: 6px"
                  class="refresh-button"
                >
                  <ion-icon name="refresh-outline"></ion-icon>
                </ion-button>
              </ion-item>
            </ion-list>
          </div>
        </ion-accordion>
      </ion-accordion-group>

      <ion-accordion-group
        [value]="openAutomationsAccordions"
        multiple="true"
        *ngIf="conversation && authService.tenant.isCustomActionsEnabled"
        class="accordion-container"
      >
        <ion-accordion value="automations">
          <ion-item slot="header" (click)="getAutomationRuns()" style="padding: 0">
            <ion-label class="step-label"> Automations </ion-label>
          </ion-item>
          <div class="step-content" slot="content">
            <ion-card class="outline-card" style="margin: 5px 15px" *ngIf="automationRuns?.length">
              <ion-list lines="none" class="no-padding">
                <ion-item
                  class="no-padding"
                  *ngFor="let run of automationRuns"
                  [ngClass]="{ 'linear-gradient-subtle-animated': run.status === 'running' }"
                >
                  <ion-spinner
                    name="crescent"
                    class="automation-left-icon"
                    slot="start"
                    *ngIf="run.status === 'pending' || run.status === 'running'"
                  ></ion-spinner>
                  <ion-icon
                    slot="start"
                    name="checkmark-circle"
                    class="automation-left-icon"
                    style="color: var(--ion-color-success)"
                    *ngIf="run.status === 'completed'"
                  ></ion-icon>
                  <ion-icon
                    slot="start"
                    name="close-circle"
                    class="automation-left-icon"
                    style="color: var(--ion-color-danger)"
                    *ngIf="run.status === 'failed' || run.status === 'canceled'"
                  ></ion-icon>
                  <ion-label text-wrap>
                    <h3>{{ run.automation?.name ?? 'Automation no longer available' }}</h3>
                    <p>
                      <span style="text-transform: capitalize">{{ run.status }}</span>
                      <span *ngIf="run.status === 'running'">...</span>
                      <span
                        *ngIf="run.completedAt"
                        style="margin-left: 4px"
                        title="{{ run.completedAt | date: 'MMM d yyyy h:mm a' }}"
                      >
                        {{ displayDateFrom(run.completedAt) }}
                      </span>
                    </p>
                  </ion-label>
                  <ion-label slot="end">
                    <a (click)="viewAutomationLogs(run.automationId, run.id)">Logs</a>
                  </ion-label>
                </ion-item>
              </ion-list>
            </ion-card>
            <ion-list lines="none" class="no-padding">
              <ion-item>
                <ion-button
                  (click)="selectAutomationToRun()"
                  color="light"
                  [disabled]="disableButtons"
                  *ngIf="canRunAutomations"
                  class="no-margin"
                >
                  <ion-icon name="add-circle" class="padded-icon"></ion-icon>Run automation...
                </ion-button>
                <ion-button
                  fill="clear"
                  color="dark"
                  (click)="getAutomationRuns()"
                  style="margin-left: 6px"
                  class="refresh-button"
                >
                  <ion-icon name="refresh-outline"></ion-icon>
                </ion-button>
              </ion-item>
            </ion-list>
          </div>
        </ion-accordion>
      </ion-accordion-group>

      <ion-accordion-group multiple="true" *ngIf="conversation" class="accordion-container">
        <ion-accordion value="conversationLinks">
          <ion-item slot="header" (click)="enableConversationLinks()" style="padding: 0">
            <ion-label class="step-label"> Linked Conversations </ion-label>
          </ion-item>
          <div class="step-content" slot="content">
            <app-conversation-links-list
              *ngIf="conversationLinksEnabled"
              [conversationId]="conversation.id"
              [conversationFriendlyId]="conversation.friendlyId"
              [disabled]="disableButtons"
              [projectId]="conversation.projectId"
            ></app-conversation-links-list>
          </div>
        </ion-accordion>
      </ion-accordion-group>

      <ion-accordion-group multiple="true" class="accordion-container" *ngIf="conversation">
        <ion-accordion value="previousConversations">
          <ion-item slot="header" (click)="getPreviousConversations()" style="padding: 0">
            <ion-label class="step-label"> Recent Conversations </ion-label>
          </ion-item>
          <div class="step-content" slot="content" style="margin: 0 5px">
            <div class="flexed" [hidden]="!submittedBy?.id">
              <span
                class="tab-nav-link"
                [ngClass]="{ 'tab-nav-active': recentConversationsTab === 'user' }"
                (click)="recentConversationsTab = 'user'; getPreviousConversations(true)"
                style="padding: 10px 0; font-size: 0.8rem"
              >
                By User
              </span>
              <span
                class="tab-nav-link"
                [ngClass]="{ 'tab-nav-active': recentConversationsTab === 'account' }"
                (click)="recentConversationsTab = 'account'; getPreviousConversations(true)"
                style="padding: 10px 0; font-size: 0.8rem"
              >
                By Account
              </span>
            </div>
            <app-conversation-list
              #previousConversationsComponent
              [sortDesc]="true"
              [sortField]="'createdAt'"
              [whereClauses]="getWhereClauseForPreviousConversations()"
              [disableAssignment]="true"
              [disableSelection]="true"
              [showEmptyState]="true"
              [limit]="7"
              [routerPath]="getRouterPath()"
              routerDirection="root"
              [showTags]="true"
            ></app-conversation-list>
          </div>
        </ion-accordion>
      </ion-accordion-group>

      <ion-accordion-group multiple="true" *ngIf="conversation" class="accordion-container">
        <ion-accordion value="similarConversations">
          <ion-item slot="header" (click)="getSimilarConversations()" style="padding: 0">
            <ion-label class="step-label"> Similar Conversations </ion-label>
          </ion-item>
          <div class="step-content" slot="content" style="margin: -10px 5px 0 5px">
            <div
              style="display: flex; justify-content: center; align-items: center; height: 35px; margin-top: 10px"
              *ngIf="isLoadingSimilarConversations"
            >
              <ion-spinner name="crescent" style="width: 25px; height: 25px; margin-left: 5px"></ion-spinner>
            </div>
            <app-conversation-list
              #similarConversationsComponent
              [conversations]="similarConversations"
              [disableAssignment]="true"
              [disableSelection]="true"
              [showSummary]="true"
              [routerPath]="getRouterPath()"
              routerDirection="root"
              [showEmptyState]="true"
              [showTags]="true"
              *ngIf="!isLoadingSimilarConversations && similarConversations?.length"
            ></app-conversation-list>
          </div>
        </ion-accordion>
      </ion-accordion-group>

      <ion-list class="transparent-bg no-padding" lines="none" *ngIf="conversation" style="margin-top: 10px">
        <ion-item *ngIf="referralUrl">
          <ion-label text-wrap>
            <p>Sent from</p>
            <h3>
              <a href="{{ referralUrl }}">{{ referralUrl }} <ion-icon name="open-outline"></ion-icon></a>
            </h3>
          </ion-label>
        </ion-item>
        <ion-item *ngIf="authService.isAiFeatureEnabled('customerSentiment') && conversation.sentiment">
          <ion-label text-wrap>
            <p>Sentiment</p>
            <h3>{{ conversation.sentiment }}% positive</h3>
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-label text-wrap>
            <p>Opened</p>
            <h3>
              {{ conversation.createdAt | date: 'MMM d yyyy h:mm a' }}
              {{
                conversation.initialMessage?.sourceType === 'slack-bot-dm'
                  ? '(via Bot DM)'
                  : conversation.wasManuallyCreated
                    ? '(manually)'
                    : '(automatically)'
              }}
            </h3>
          </ion-label>
        </ion-item>
        <ion-item *ngIf="conversation.respondedAt">
          <ion-label text-wrap>
            <p>Time to respond</p>
            <h3>
              {{ displayDuration(conversation.responseTimeWorking) }}
              <ion-icon
                name="cloud-offline-outline"
                *ngIf="conversation.excludeAnalytics"
                ngxTippy
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  content: 'Not included in analytics'
                }"
              ></ion-icon>
            </h3>
          </ion-label>
        </ion-item>
        <ion-item *ngIf="conversation.closedAt" class="resolution-time-field">
          <ion-label text-wrap>
            <p>Time to resolve</p>
            <h3>
              {{ displayDuration(conversation.resolutionTimeWorking) }}
              <ion-icon
                name="cloud-offline-outline"
                *ngIf="conversation.excludeAnalytics"
                ngxTippy
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  content: 'Not included in analytics'
                }"
              ></ion-icon>
              <a
                class="edit-resolution-button"
                (click)="editResolutionTime()"
                ngxTippy
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  content: 'Edit resolution time'
                }"
                ><ion-icon name="pencil"></ion-icon
              ></a>
            </h3>
          </ion-label>
        </ion-item>
        <ion-item *ngIf="conversation.closedAt">
          <ion-label text-wrap>
            <p>Waiting on agent</p>
            <h3>
              {{ displayDuration(conversation.waitingOnAgentTimeWorking) }}
              <ion-icon
                name="cloud-offline-outline"
                *ngIf="conversation.excludeAnalytics"
                ngxTippy
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  content: 'Not included in analytics'
                }"
              ></ion-icon>
            </h3>
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-label text-wrap>
            <p>Last updated</p>
            <h3>{{ conversation.updatedAt | date: 'MMM d yyyy h:mm a' }}</h3>
          </ion-label>
        </ion-item>
        <ion-item *ngFor="let key of conversation.metadata | keyvalue">
          <ion-label text-wrap>
            <p>{{ key.key }}</p>
            <h3>{{ key.value }}</h3>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>

    <div *ngIf="sidebarTab === 'knowledge'" style="margin-top: -10px">
      <app-kb-search
        [customerId]="conversation.customerId"
        (didComposeResponse)="kbSearchDidComposeResponse($event)"
        #kbSearch
      ></app-kb-search>
    </div>
  </div>
</div>
